import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../../store';
import SliderListItem from '../../../../../../list-items/SliderListItem';
import { previewHistoryBatch } from '../../../../store/extensions';

const VisualizerScaleListItem = (props) => {
    const { glowSettingsScale, updateVisualizerSettings, maxGlowScale } = props;
    
    const onGlowScaleChange = (value) => {
        previewHistoryBatch.start();
        
        updateVisualizerSettings({ 
            glowSettings: { scale: value } 
        });
    };
    
    return (
        <SliderListItem
            title='Scale'
            value={glowSettingsScale}
            displayMultiplier={100 / maxGlowScale}
            min={0}
            max={100}
            step={1}
            onValueChange={onGlowScaleChange}
        />
    );
};

const mapStateToProps = (state) => {
    const { scale: glowSettingsScale } = state.createPreview.present.videoSettings.visualizer.glowSettings;
    const { maxGlowScale } = state.create.maxValues;

    return { 
        glowSettingsScale,
        maxGlowScale
    };
}

const mapDispatchToProps = (dispatch) => {
    const updateVisualizerSettings = (properties) => dispatch(createActions.updateVisualizerSettings(properties));
    return { updateVisualizerSettings }
}

export default connect(mapStateToProps, mapDispatchToProps)(VisualizerScaleListItem);